export default {
  id: "task",
  initial: "checking",
  states: {
    checking: {
      invoke: {
        id: "getTaskProgress",
        src: "getTaskProgress",
        onDone: [
          {
            target: "unregistered",
            actions: ["setTasks", "setTaskInfo"],
            cond: "unregisteredTask"
          },
          {
            target: "checkZonesRole",
            actions: ["setUserInfoFromTaskInfo", "setTasks", "setPartitionInfoFromCGIDATA", "checkZoneOrSkip"],
            cond: "hasRegisteredTask"
          }
        ],
        onError: [
          {
            target: "exception.expired",
            cond: "isActivityEnd"
          },
          {
            target: "exception"
          }
        ]
      }
    },
    exception: {
      initial: "countdownStart",
      states: {
        countdownStart: {
          entry: ["busyDialogReport"],
          invoke: {
            id: "busy_countdown",
            src: "busyCountDown"
          },
          on: {
            TICK: {
              actions: "busyCountTick"
            },
            STOP_COUNT: "countdownEnd"
          }
        },
        countdownEnd: {},
        expired: {}
      }
    },
    unregistered: {
      always: "#appActivity.welcome"
    },
    checkZonesRole: {
      initial: "idle",
      states: {
        idle: {
          on: {
            PLATFORM_NOT_MATCH: "platformNotMatch",
            CHECK_ZONE: "checkZones",
            SKIP: "#task.registered"
          }
        },
        platformNotMatch: {},
        checkZones: {
          invoke: {
            id: "selectZone",
            src: "getZoneInfo",
            onDone: {
              target: "checkRole",
              actions: ["setZoneList", "setSelectedZoneFromList"]
            },
            onError: {
              target: "checkRole"
            }
          }
        },
        checkRole: {
          invoke: {
            id: "selectRole",
            src: "getRoleInfo",
            onDone: {
              target: "#task.registered",
              actions: ["setSelectedRole"]
            },
            onError: {
              target: "#task.registered"
            }
          }
        }
      }
      // always: "registered"
    },
    getUserAvatarInGame: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            src: "getUserInfoInGame",
            onDone: {
              target: "#appActivity.participate",
              actions: ["setUserInfoInGame"]
            },
            onError: "#appActivity.participate"
          }
        }
      }
    },
    registered: {
      always: [
        {
          cond: "isInMSDK",
          target: "#task.getUserAvatarInGame"
        },
        {
          target: "#appActivity.participate"
        }
      ]
    }
  }
}
